import { useQuery } from "@tanstack/react-query";
import {
  apiGetArtistTypeMappings,
  apiGetGenreMappings,
  apiGetPendingCount,
  apiGetPollstarStatus,
  apiGetSyncSchedule,
  type PollstarMappingStatus,
} from "@api/pollstar";

export const POLLSTAR_KEYS = {
  pendingCount: ["pollstarPendingCount"] as const,
  genres: (status?: PollstarMappingStatus) => ["pollstarGenreMappings", status ?? "all"] as const,
  artistTypes: (status?: PollstarMappingStatus) => ["pollstarArtistTypeMappings", status ?? "all"] as const,
  status: ["pollstarStatus"] as const,
  schedule: ["pollstarSyncSchedule"] as const,
};

export function usePollstarPendingCount(enabled = true) {
  return useQuery({
    queryKey: POLLSTAR_KEYS.pendingCount,
    queryFn: apiGetPendingCount,
    enabled,
  });
}

export function useGenreMappings(status?: PollstarMappingStatus) {
  return useQuery({
    queryKey: POLLSTAR_KEYS.genres(status),
    queryFn: () => apiGetGenreMappings(status),
  });
}

export function useArtistTypeMappings(status?: PollstarMappingStatus) {
  return useQuery({
    queryKey: POLLSTAR_KEYS.artistTypes(status),
    queryFn: () => apiGetArtistTypeMappings(status),
  });
}

export function usePollstarStatus() {
  return useQuery({
    queryKey: POLLSTAR_KEYS.status,
    queryFn: apiGetPollstarStatus,
  });
}

export function usePollstarSchedule() {
  return useQuery({
    queryKey: POLLSTAR_KEYS.schedule,
    queryFn: apiGetSyncSchedule,
  });
}
